
import request from '@/utils/request'

// 获取 大客户分析列表-九州通
export function getBigCustomerJointown (params) {
  return request({
    url: '/v1/big-customer/jointown',
    method: 'post',
    data: params
  })
}

// 获取 大客户分析列表
export function getBigCustomerList (params) {
  return request({
    url: '/v1/big-customer/list',
    method: 'post',
    data: params
  })
}

// 获取 大客户分析明细列表-九州通
export function getBigCustomerDetailJointown (params) {
  return request({
    url: '/v1/big-customer/jointown/detail',
    method: 'post',
    data: params
  })
}

// 获取 大客户分析明细列表
export function getBigCustomerDetail (params) {
  return request({
    url: '/v1/big-customer/detail/list',
    method: 'post',
    data: params
  })
}
// 获取日期
export function getFlowTime () {
  return request({
    url: '/v1/flow-time/jianmin/phone',
    method: 'post'
  })
}
